import { Vehicle } from 'data-layer-cr/dist/models';
import { TextValuesPayload } from 'src/store/inspectionForm/slice/inspectionFormSlice';
import DEFAULT_SERIAL_MOTOR from 'src/constants/serialMotor';
import profileTypes from 'src/constants/profileTypes';
import FormShape from './FormShape';

/**
 * Extract a single improvement from the provided TextValuesPayload
 *
 * @param textValues - The text values
 * @param fieldName - The field to extract
 */
export function extractImprovement(
  textValues: TextValuesPayload,
  fieldName: string,
): string | boolean {
  const found = textValues.carImprovements.find(
    (improv): boolean => improv.name === fieldName,
  );
  if (found) {
    return found.value;
  }
  return '';
}

type InitialInspectionData = {
  textValues: TextValuesPayload;
  vehicle: Vehicle;
  profileType?: string;
  hasLicense: boolean;
};

/**
 * Converts the provided source TextValuesPayload to an instance of FormShape
 *
 * @param textValues - The source values
 * @param vehicle
 */
export function makeInitialValues({
  textValues,
  vehicle,
  hasLicense,
  profileType,
}: InitialInspectionData): FormShape {
  return {
    previousDamage: textValues.previousDamages,
    vinNumber: vehicle.serialChassis,
    licensePlate: vehicle.licensePlate,
    type: vehicle.type,
    serialMotor: vehicle.serialMotor,
    isCollective: profileType === profileTypes.COLLECTIVE,
    carImprovements: extractImprovement(
      textValues,
      'carImprovements',
    ) as string,
    rines: extractImprovement(textValues, 'rines') as boolean,
    soundSystem: extractImprovement(textValues, 'soundSystem') as boolean,
    hasLicense,
  };
}

/**
 * Converts the form data to the required TextValuesPayload
 *
 * @param data - The form data
 */
export function formShapeToTextValues(data: FormShape): TextValuesPayload {
  return {
    previousDamages: data.previousDamage,
    carImprovements: [
      { name: 'rines', value: data.rines },
      { name: 'soundSystem', value: data.soundSystem },
      { name: 'carImprovements', value: data.carImprovements },
    ],
    vinNumber: data.vinNumber.trim(),
    licensePlate: data.licensePlate.trim(),
    serialMotor: data.serialMotor || DEFAULT_SERIAL_MOTOR,
    type: data.type.trim(),
  };
}
